export const definePermission = (payload) => ({
    type: "DEFINE_PERMISSIONS",
    payload
});